import { Box } from '@mui/material';
import { AuthService } from '../../../services/auth.service';
import RoleLensBoard from './RoleLensBoard';
import CommercialDashboard from '../../commercial/CommercialDashboard';

/**
 * The Thread style of the commercial home: export LCs as steps from opening to realisation, with expiring LCs on the side.
 * The server leaves out any section the caller has no key for, so this stays a thin wrapper.
 */
export default function CommercialLensBoard() {
    const institutionId = AuthService.getSelectedInstitution();
    return (
        <Box sx={{ minWidth: 0 }} data-help-page="dashboard.thread.commercial">
            <RoleLensBoard institutionId={institutionId} lens="commercial" fallback={<CommercialDashboard />} />
        </Box>
    );
}
